// The foresight steps (#630): module id → its participant route (the module's
// manifest `participant.route`) and the screen that runs it. Each step works on
// one foresight scenario, carried in ?skenaario=.
import lazyWithReload from '../utils/lazyWithReload';

export const FORESIGHT_STEPS = {
  'foresight_scope.v1': { route: '/ennakointi/rajaus', Screen: lazyWithReload(() => import('./scope/ScopeStep')) },
  'change_drivers.v1': { route: '/ennakointi/muutosvoimat', Screen: lazyWithReload(() => import('./drivers/DriversStep')) },
  'scenarios.v2': { route: '/ennakointi/tulevaisuuskuvat', Screen: lazyWithReload(() => import('./scenarios/ScenariosStep')) },
  'preferred_future.v1': { route: '/ennakointi/tavoite', Screen: lazyWithReload(() => import('./preferred/PreferredFutureStep')) },
  'backcasting.v1': { route: '/ennakointi/polku', Screen: lazyWithReload(() => import('./backcasting/BackcastingStep')) },
  'wildcard_test.v1': { route: '/ennakointi/villi-kortti', Screen: lazyWithReload(() => import('./wildcard/WildcardStep')) },
};

export const FIRST_STEP = 'foresight_scope.v1';

/** The handoff each step produces, in the per-scenario `progress` of GET /foresight/scenarios. */
export const STEP_OUTPUT = {
  'foresight_scope.v1': 'foresight_brief',
  'change_drivers.v1': 'driver_set',
  'scenarios.v2': 'scenario_list',
  'preferred_future.v1': 'preferred_future',
  'backcasting.v1': 'backcasting_path',
  'wildcard_test.v1': 'stress_test',
};

/** Translation key of a step's label. Keyed by family: t() splits keys on '.', so a module id can't be one. */
export function stepLabelKey(moduleId) {
  return `foresight.steps.${String(moduleId).split('.')[0]}`;
}

/** A step's user-facing URL for an instance, optionally on one scenario. */
export function foresightPath(instanceId, moduleId = FIRST_STEP, scenarioId = null) {
  const q = new URLSearchParams({ kid: instanceId });
  if (scenarioId) q.set('skenaario', scenarioId);
  return `${(FORESIGHT_STEPS[moduleId] || FORESIGHT_STEPS[FIRST_STEP]).route}?${q}`;
}
